import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';
import NewsTitle from '../../../components/newsTitle';
import NewsList from '../../../components/newsList';
import ShopList from '../../../components/shopList';
import Ad from '@ifeng-fe/ui_pc_ad';

class CenterNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { financeListFirstItem, financeTitle, financeList0, shopInStock, financeList1, stockListAd, stockRSAd, replaceShopConfig2 },
        } = this.props;

        return (
            <div className={styles.center_box}>
                <Chip id="200139" type="struct" title="财经标题" groupName="财经" content={financeTitle}>
                    <NewsTitle size="middle" />
                </Chip>

                <Chip
                    id="288949"
                    type="recommend"
                    title="财经列表第一条"
                    groupName="财经"
                    content={financeListFirstItem}
                    translate="handleNewsData">
                    <NewsList hasTitleImg size="long" />
                </Chip>
                
                <Chip
                    id="288951"
                    type="recommend"
                    title="财经列表1-人工干预"
                    groupName="财经"
                    content={financeList0}
                    translate="handleNewsData">
                    <NewsList size="long" />
                </Chip>
                {replaceShopConfig2.isShow ?
                    <NoSSR>
                        <Ad content={stockRSAd} styleName={styles.adBox} />
                    </NoSSR> : 
                    <ShopList size="long" content={shopInStock} sourceName="shopInStock" />
                }
                <Chip
                    id="288952"
                    type="recommend"
                    title="财经列表2-人工干预"
                    groupName="财经"
                    content={financeList1}
                    translate="handleNewsData">
                    <NewsList size="long" ad={stockListAd} />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(CenterNewsBox);
